import { LANGUAGE_SET, LANGUAGE_RESET } from "../actionNames";

export function setLanguage(language) {
  return (dispatch) => {
    dispatch({
      type: LANGUAGE_SET,
      language,
    });
  };
}

export function resetLanguage() {
  return (dispatch) =>
    dispatch({
      type: LANGUAGE_RESET,
    });
}
